import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import WorkflowAPI from "../../api/WorkflowAPI";

const workflows = [
  {
    id: "1010",
    _id: "1010",
    Name: "Workflow 1",
    Description: "My first workflow",
    Trigger: {
      Type: "manual-file-import",
      Name: "File Upload",
      Description: "",
      Icon: "mdi mdi-upload",
    },
    Actions: [
      {
        ActionID: 1,
        Name: "Validate Contact Record Entries",
        Description: "",
        ModuleAPIName: "Contacts",
        Type: "validate",
        FieldMapping: [
          {
            Source: "File",
            SourceKey: "OwnerName",
            Field: "Name",
          },
          {
            Source: "File",
            SourceKey: "OwnerEmail",
            Field: "Email",
          },
        ],
      },
      {
        ActionID: "{{UUID_2}}",
        Name: "Import & Update Contact Records",
        Description: "",
        ModuleAPIName: "Contacts",
        Type: "record-create-update",
        FieldMapping: [
          {
            Source: "File",
            SourceKey: "OwnerName",
            Field: "Name",
          },
          {
            Source: "File",
            SourceKey: "OwnerEmail",
            Field: "Email",
          },
        ],
        ModifiesData: true,
        AvailableToFutureActions: true,
      },
      {
        ActionID: "{{UUID_3}}",
        Name: "Validate Deal Record Entries",
        Description: "",
        ModuleAPIName: "Deals",
        Type: "validate",
        FieldMapping: [
          {
            Source: "File",
            SourceKey: "Status",
            Field: "Status",
          },
          {
            Source: "File",
            SourceKey: "DealName",
            Field: "Name",
          },
          {
            Source: "Action",
            ActionID: "{{UUID_2}}",
            Field: "OwnerContact",
          },
        ],
      },
      {
        ActionID: "{{UUID_4}}",
        Name: "Import & Update Deal Records",
        Description: "",
        ModuleAPIName: "Deals",
        Type: "record-create-update",
        FieldMapping: [
          {
            Source: "File",
            SourceKey: "Status",
            Field: "Status",
          },
          {
            Source: "File",
            SourceKey: "DealName",
            Field: "Name",
          },
          {
            Source: "Action",
            ActionID: "{{UUID_2}}",
            Field: "OwnerContact",
          },
        ],
      },
    ],
  },
];

const useWorkflow = ({
  workflowID,
  disabled = false,
}: {
  workflowID: string;
  disabled?: boolean;
}) => {
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const workflow = useQuery({
    queryKey: ["workflow", workflowID],
    queryFn: () =>
      WorkflowAPI.getWorkflowByID(workflowID).then(
        (data) => data.data.data.workflow
      ),
    enabled: !disabled && !!workflowID && queriesEnabled,
    staleTime: Infinity,
  });

  return {
    workflow: workflow.data,
    workflowLoading: workflow.isLoading,
    workflowError: workflow.error ? getErrorMessage(workflow.error) : null,
  };
};

export default useWorkflow;
